<template>
<div class="content">
<!--Begin Banner-->
<BannerComponent />
<!--End Banner-->

<!-- start content -->
<div id="content-part">

    <!-- start megapanel-bar -->
    <div class="megapanel-bar parahgraph-bar">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <p class="large-text text-center">Mensen houden van simpel en dat is een feit. Maar hoe bouw je ingewikkelde applicaties en websites die toch simpel in gebruik zijn? Dit zijn vraagstukken waar wij onze over buigen bij Mirzacles IT. Wij vereenvoudigen complexe vraagstukken en vertalen deze naar verassende oplossingen voor de high traffic websites die wij bouwen.</p>
                    
                    <div class="caption-panel">
                        <div class="line1"></div>
                        <div class="line2"></div>
                        <div class="line3"></div>
                        <div class="figure-1">
                            
                        </div>
                        <div class="text">
                            <p class="large-text">Doordat wij maandelijks miljoenen bezoekers aantrekken naar de websites van onze klanten krijg je als developer de mogelijkheid om je ideeën uit te werken en te split testen.</p>
                            <!-- <a href="#" class="anchor">Learn More</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ends megapanel-bar -->
    
    <!-- start megapanel-bar -->
    <div class="megapanel-bar over-bar">
        <div class="container max-1665">
            <div class="row">
                <div class="figure-2 col-6">
                </div>
                <div class="col-6 text">
                    <div class="megatitle2"><h2>Over Mirzacles IT</h2></div>
                    <p class="large-text">Mirzacles IT & Consulting B.V. is een snelgroeiende organisatie in hartje Rotterdam, die high performance websites bouwt, onderhoud en optimaliseert. Met een groep van 7 PHP (Laravel) professionals werken wij dag in en dag uit aan de meest innoverende concepten in ons vakgebied.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- ends megapanel-bar -->
    
    <!-- start megapanel-bar -->
    <div class="megapanel-bar jobOpening-bar">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <p class="large-text text-center">Om te accelereren en verder op te schalen de komende jaren, zoeken wij naar <br/>toekomstige (ondernemende) collega’s die samen met ons de top willen bereiken <br/>en willen groeien in hun vakgebied. </p>
                </div>
            </div>
            <div class="caption-panel2 bg-gray">
                <div class="row">
                    <div class="figure-3 col-6">
                    </div>
                    <div class="col-6 text">
                        <p class="large-text">Werken bij Mirzacles IT is niet alleen heel leuk, spannend en leerzaam, maar loont ook. Naast een royaal salaris krijg je per jaar ook een bonus gebaseerd op de winst van ons bedrijf. En wat dacht je van leuke etentjes? Volledige reiskostenvergoeding? Laptop van de zaak, bedrijf uitjes en ruimte voor persoonlijke groei?</p>
                    </div>
                    <div class="col-12">
                        <div class="bottom-text">
                            <p class="large-text">Zeg maar doei tegen je saaie kantoorbaan en “Hello, here I come” tegen je nieuwe baan <br/>bij Mirzacles IT. Kijk snel welke vacatures open staan!</p>
                            <router-link to="/vacancies" class="primarybtn">Bekijk alle vacatures  </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ends megapanel-bar -->

</div>
<!-- end content -->
</div>
</template>

<style scoped>
[class^="figure"] {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.figure-1 {
  background-image: url('../assets/images/img-1.jpeg');
}
.figure-2 {
  background-image: url('../assets/images/img-2.png');
}
.figure-3 {
  background-image: url('../assets/images/img-3.jpeg');
}
</style>

<script>
import BannerComponent from '../components/BannerComponent';

export default {
  name: 'Home',
	components: {
		BannerComponent
	}
}
</script>
